export const $header = $('header.header');
export const $grid = {
  xs: 0,
  sm: 576,
  md: 920,
  lg: 1120,
  xl: 1280,
};



// WEBPACK FOOTER //
// ./scripts/util/const.js